export enum HeaderMaxtrack {
  MAXPB_CMD_KEEP_ALIVE = "0000",
  MAXPB_CMD_POSITION = "0001",

  MAXPB_CMD_ACK = "0002",
  MAXPB_CMD_NACK = "0003",

  MAXPB_CMD_GENERATE_POSITION = "0004",
  MAXPB_CMD_REQUEST_POSITION_LOG = "0005",

  MAXPB_CMD_FILE_CHANGE = "0006",
  MAXPB_CMD_FILE_REQUEST_DATA = "0007",
  MAXPB_CMD_FILE_DATA = "0008",
  MAXPB_CMD_FILE_ERASE = "0009",
  MAXPB_CMD_FILE_CANCEL = "000a",
  MAXPB_CMD_FILE_UPLOAD_INIT = "000b",
  MAXPB_CMD_FILE_UPLOAD_REQUEST_DATA = "000c",
  MAXPB_CMD_FILE_UPLOAD_DATA = "000d",
  MAXPB_CMD_FILE_CHANGE_BY_DIFF = "000e",

  MAXPB_CMD_REQUEST_STATUS = "0010",
  MAXPB_CMD_STATUS = "0011",
  MAXPB_CMD_MULTIPLE_REPORT_LORA = "0012",
  MAXPB_CMD_REQUEST_SETUP = "0013",
  MAXPB_CMD_SETUP_DATA = "0014",
  MAXPB_CMD_REPORT_BLACKBOX = "0015",

  MAXPB_CMD_REQUEST_POSITION_IN_RAM = "0016",

  MAXPB_CMD_WRITE_RS232 = "0017",
  MAXPB_CMD_OPEN_DATA_ADD = "0018",
  MAXPB_CMD_ROUTER = "0019",
  MAXPB_CMD_USER = "001a",
  MAXPB_CMD_ACCELEROMETER_EVENT_DETAIL = "001b",
  MAXPB_CMD_SCAN_OTHER_OPERATOR_CELLS = "001c",
  MAXPB_CMD_SET_INPUT_COUNTER = "001d",
  MAXPB_CMD_REQUEST_LORA_SETUP = "001e",
  MAXPB_CMD_LORA_SETUP_DATA = "001f",

  MAXPB_CMD_SETUP_DEFAULT = "0020",
  MAXPB_CMD_PASSWORD = "0021",
  MAXPB_CMD_PASSWORD_STORE = "0022",
  MAXPB_CMD_SET_VARIABLES = "0023",
  MAXPB_CMD_GET_VARIABLES = "0024",
  MAXPB_CMD_GET_VARIABLES_DATA = "0025",
  MAXPB_CMD_FORMAT_POSITION_LOG = "0026",
  MAXPB_CMD_CLEAR_POSITION_LOG = "0027",
  MAXPB_CMD_EXECUTE_EMBEDDED_ACTION = "0028",
  MAXPB_CMD_SET_VARIABLES_ON_FLASH = "0029",
  MAXPB_CMD_REQUEST_LORA_WAN_NWK_LIST = "002a",
  MAXPB_CMD_LORA_WAN_NWK_LIST_DATA = "002b",
  MAXPB_CMD_REQUEST_TX_PACKET = "002c",
  MAXPB_CMD_CLEAR_ECU_INFO = "002d",
  MAXPB_CMD_REQUEST_CUSTOM_REPORT_DATA = "002e",
  MAXPB_CMD_REPORT_SIGFOX = "002f",

  MAXPB_CMD_SET_POWER = "0030",
  MAXPB_CMD_OUTPUT = "0031",
  MAXPB_CMD_SET_OPERATIONAL_STATE = "0032",
  MAXPB_CMD_IGN_AUTO_CALIB = "0033",
  MAXPB_CMD_ACC_RESTART_CALIB = "0034",
  MAXPB_CMD_DISCONNECT = "0036",
  MAXPB_CMD_LORA_GATEWAY_CONTROL = "0037",
  MAXPB_CMD_LORA_COMMAND = "0038",
  MAXPB_CMD_START_BLUETOOTH = "003a",
  MAXPB_CMD_FILE_EDIT = "003b",
  MAXPB_CMD_FILE_EDIT_RESULT = "003c",
  MAXPB_CMD_LOG_INFO_REQUEST = "003d",
  MAXPB_CMD_LOG_INFO_DATA = "003e",

  MAXPB_CMD_KEEP_CHANNEL_OPEN = "0201",
  MAXPB_CMD_YOU_CAN_CLOSE_CHANNEL = "0202",
  MAXPB_CMD_SET_DATETIME = "0203",

  MAXPB_CMD_TEST = "0100",
  MAXPB_CMD_TEST_RESPONSE = "0101",
  MAXPB_CMD_SETUP = "0102",
  MAXPB_CMD_POS_CONNECT = "0106",
  MAXPB_CMD_RS232_CONNECT = "0107",
  MAXPB_CMD_CHANGE_SETUP = "0108",

  MAXPB_CMD_INTERNAL_TEST = "1000",
  MAXPB_CMD_INTERNAL_TEST_RESPONSE = "1001",
  MAXPB_CMD_INTERNAL_SETUP = "1002",
  MAXPB_CMD_INTERNAL_GET_SETUP = "1003",
  MAXPB_CMD_INTERNAL_SET_CALIBRATION = "1004",
  MAXPB_CMD_INTERNAL_PASSWORD_MASTER = "1005",
  MAXPB_CMD_INTERNAL_POS_CONNECT = "1006",
  MAXPB_CMD_SMS_INFO_REQ = "1007",
  MAXPB_CMD_INTERNAL_CREATE_RENT_PASSWORD = "1009",
  MAXPB_CMD_WRITE_ID = "100a",
  MAXPB_CMD_INTERNAL_CHANGE_MAXIO_SETUP = "100b",
  MAXPB_CMD_INTERNAL_CHANGE_A40_SETUP = "100c",
  MAXPB_CMD_INTERNAL_MAXIO_SETUP = "100d",
  MAXPB_CMD_INTERNAL_UART_REDIRECT = "1011",
  MAXPB_CMD_INTERNAL_WIFI_MODE = "1012",

  MAXPB_CMD_CFG_ADAPTER = "0c00",
  MAXPB_CMD_SELECT_ADAPTER = "0c01",
  MAXPB_CMD_UPDATE_ADAPTER = "0c02",
  MAXPB_CMD_FT_ADAPTER = "0c03",
}
